import { useMemo } from "react";

import { Barber } from "../../types";
import { useFavoriteBarberIds } from "./use-favorite-barber-ids";

export const useFavoriteBarbers = (barbers: Barber[]): Barber[] => {
  const favoriteIds = useFavoriteBarberIds();

  const favoriteBarbers = useMemo(
    () =>
      favoriteIds
        ? barbers.filter((barber) => favoriteIds.includes(barber?.id))
        : [],
    [barbers, favoriteIds]
  );

  return favoriteBarbers;
};
